import React, { useState } from 'react';
import { Users, BarChart3 } from 'lucide-react';
import UtilizationChart from './UtilizationChart';
import ProjectPerformance from './ProjectPerformance';
import { useDashboard } from '../context/DashboardContext';

const DashboardTabs = () => {
  const [activeTab, setActiveTab] = useState('performance');
  const { dashboardData } = useDashboard();

  return (
    <div className="dashboard-tabs">
      <div className="tabs-header">
        <button 
          className={`tab-button ${activeTab === 'utilization' ? 'active' : ''} disabled`}
          disabled={true}
          title="Team Performance tab is temporarily disabled"
        >
          <Users size={16} />
          Team Performance
        </button>
        <button 
          className={`tab-button ${activeTab === 'performance' ? 'active' : ''}`}
          onClick={() => setActiveTab('performance')}
        >
          <BarChart3 size={16} />
          Project Performance
        </button>
      </div>

      <div className="tab-content">
        {activeTab === 'utilization' && (
          <div className="dashboard-section">
            <UtilizationChart />
          </div>
        )}
        
        {activeTab === 'performance' && (
          <div className="dashboard-section">
            <ProjectPerformance />
          </div>
        )}
      </div>
    </div>
  );
};

export default DashboardTabs;